<template>
  <div>
    <div class="table-responsive col-lg-12">
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Company Name</th>
          <th>URL</th>
          <th>Brands</th>
          <th>Markets</th>
          <th>Aff Links</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="affiliateCompany in affiliateCompanies" :key="affiliateCompany.id" >
          <td>
            <router-link :to="'/advertisers/affiliatecompany/' + affiliateCompany.id" >{{ affiliateCompany.name }}</router-link>
          </td>
          <td>{{ affiliateCompany.url }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { AFFILIATE_COMPANIES_SET } from '../../../../store/mutation-types'
import axios from 'axios'

export default {
  computed: {
    ...mapGetters({
      affiliateCompanies: 'getAffiliateCompanies'
    })
  },
  mounted () {
    this.loadAffcompanies()
  },
  methods: {
    async loadAffcompanies () {
      try {
        let resp = await axios.get('/advertisers/affiliate-companies')
        this.$store.commit(AFFILIATE_COMPANIES_SET, resp.data)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/AffiliateCompanies/List.vue